// 只处理提示文案，商品名称、文件名等业务数据保持原值。
export function toChineseMessage(value, fallback = '操作失败，请稍后重试') {
  const message = typeof value === 'string'
    ? value.trim()
    : String(value?.response?.data?.message || value?.response?.data?.msg || value?.message || value?.msg || '').trim()

  if (/[\u3400-\u9fff]/u.test(message)) return message
  if (value?.code === 'ECONNABORTED' || value?.code === 'ETIMEDOUT' || /timeout|timed out/i.test(message)) {
    return '请求超时，请稍后重试'
  }
  if (value?.code === 'ERR_NETWORK' || /network error|failed to fetch|network request failed/i.test(message)) {
    return '网络连接失败，请检查网络后重试'
  }
  const status = Number(value?.response?.status || message.match(/status code\s+(\d{3})/i)?.[1])
  if (status === 401 || /unauthorized|not logged in|token.*(?:expired|invalid)/i.test(message)) return '登录已失效，请重新登录'
  if (status === 403 || /forbidden|access denied/i.test(message)) return '暂无权限执行此操作'
  if (status === 404) return '请求的内容不存在或已失效'
  if (status === 429) return '操作过于频繁，请稍后重试'
  if (status >= 500) return '服务暂时不可用，请稍后重试'
  return fallback
}
